import axiosInstance from "../axiosInstance";

export const staticDataService = {
  forecastExecutionTime: async (data) => {
    try {
      let response = await axiosInstance.get(
        "/static-data?type=LAST_FORECAST_EXECUTION_TIME",
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchAllStaticData: async () => {
    try {
      let response = await axiosInstance.get("/static-data");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  updateStaticData: async (id, data) => {
    try {
      let response = await axiosInstance.patch(`/static-data/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  create: async (data) => {
    try {
      let response = await axiosInstance.post(`/static-data`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchByType: async (type) => {
    try {
      let response = await axiosInstance.get(`/static-data?type=${type}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
